import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n  margin: 0;\n  padding: ", " 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { IconPopover } from '@scp/ui-shared/components/popover';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { KebabMenuItem } from './KebabMenuItem';
var TEXT = {
  BUTTON_TITLE: 'Show actions'
};
var KebabMenuItems = styled.ul(_templateObject(), baselineToRem(2));
/**
 * @example ./__docs__/KebabMenu.md
 */

export function KebabMenu(_ref) {
  var actions = _ref.actions,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 172 : _ref$width;
  return React.createElement(IconPopover, {
    icon: React.createElement(Icon, {
      name: "more-vert",
      size: 24
    }),
    buttonTitle: TEXT.BUTTON_TITLE,
    position: "top right",
    offset: "-20px 10px 0 0",
    padding: "0",
    width: width,
    concise: true,
    closesOnClick: true,
    noTriangle: true,
    withShadow: true,
    autoFocus: true
  }, React.createElement(KebabMenuItems, null, actions.map(function (action) {
    return React.createElement(KebabMenuItem, Object.assign({
      key: action.title
    }, action));
  })));
}